// src/store/slices/authSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { getToken, removeToken, setToken } from '../../utils/auth';

const initialState = {
  isAuthenticated: !!getToken(),
  user: null,
  token: getToken(),
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.isAuthenticated = true;
      state.user = action.payload.user;
      state.token = action.payload.token;
      setToken(action.payload.token, action.payload.refreshToken);
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      state.token = null;
      removeToken();
    },
    resetAuth: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      state.token = null;
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
  },
});

export const { loginSuccess, logout, resetAuth, setUser } = authSlice.actions;
export default authSlice.reducer;
